// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as UserAccessLevelEntityMapper from "../entity-mapper/UserAccessLevelEntityMapper.bs.js";
import * as ZoneClusterCampaignEntityMapper from "../entity-mapper/ZoneClusterCampaignEntityMapper.bs.js";
import * as SuccessWithNoContentEntityMapper from "../../../edit-order/app/entity-mapper/SuccessWithNoContentEntityMapper.bs.js";
import * as FilterAllocationCampaignEntityMapper from "../entity-mapper/FilterAllocationCampaignEntityMapper.bs.js";

var execute = FilterAllocationCampaignEntityMapper.execute;

var AllocationDashboardResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var FilterAllocationCampaignResponseConverter = partial_arg(AllocationDashboardResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = UserAccessLevelEntityMapper.execute;

var UserTypeResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var UserTypeResponseConverter = partial_arg$1(UserTypeResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$2(json) {
  return JSON.stringify(json);
}

var CreateMandatoryCampaignResponseConverterConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var CreateMandatoryCampaignResponseConverter = partial_arg$2(CreateMandatoryCampaignResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$3(json) {
  return JSON.stringify(json);
}

var UpdateCampaignStatusResponseConverterConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateCampaignStatusResponseConverter = partial_arg$3(UpdateCampaignStatusResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$4(json) {
  return JSON.stringify(json);
}

var CreateZonalOrClusterCampaignResponseConverterConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var CreateZonalOrClusterCampaignResponseConverter = partial_arg$4(CreateZonalOrClusterCampaignResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$5 = ZoneClusterCampaignEntityMapper.execute;

var ZoneClusterCampaignResponseConverterConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var ZoneClusterCampaignResponseConverter = partial_arg$5(ZoneClusterCampaignResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$6 = SuccessWithNoContentEntityMapper.execute;

var UpdateZoneClusterCampaignsResponseConverterConfig = {
  execute: execute$6
};

var partial_arg$6 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateZoneClusterCampaignsResponseConverter = partial_arg$6(UpdateZoneClusterCampaignsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  AllocationDashboardResponseConverterConfig ,
  FilterAllocationCampaignResponseConverter ,
  UserTypeResponseConverterConfig ,
  UserTypeResponseConverter ,
  CreateMandatoryCampaignResponseConverterConfig ,
  CreateMandatoryCampaignResponseConverter ,
  UpdateCampaignStatusResponseConverterConfig ,
  UpdateCampaignStatusResponseConverter ,
  CreateZonalOrClusterCampaignResponseConverterConfig ,
  CreateZonalOrClusterCampaignResponseConverter ,
  ZoneClusterCampaignResponseConverterConfig ,
  ZoneClusterCampaignResponseConverter ,
  UpdateZoneClusterCampaignsResponseConverterConfig ,
  UpdateZoneClusterCampaignsResponseConverter ,
  
}
/* FilterAllocationCampaignResponseConverter Not a pure module */
